"use client";

import { ApolloProvider } from "@apollo/client";
import { type PropsWithChildren, useMemo } from "react";
import { IntlProvider } from "react-intl";
import type { LangParams } from "~/app/[lang]/layout";
import { initializeApollo } from "~/lib/apollo";

interface Props extends PropsWithChildren, LangParams {
	messages: Record<string, string>;
}

export function ClientProviders({ children, lang, messages }: Props) {
	const client = useMemo(() => initializeApollo(lang), [lang]);

	return (
		<ApolloProvider client={client}>
			<IntlProvider locale={lang} messages={messages} onError={() => null}>
				{children}
			</IntlProvider>
		</ApolloProvider>
	);
}
